import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: '📄',
    text: '100% PDF'
  }, {
    icon: '⚡',
    text: 'Acceso en 5 min'
  }, {
    icon: '🤟',
    text: 'Nivel 0 → Avanzado'
  }, {
    icon: '🇦🇷',
    text: 'LSA Argentino'
  }];
  return <section className="relative bg-slate-950 text-white overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-150">
      {/* Background gradient blobs */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-151">
        <div className="absolute top-[10%] left-1/2 -translate-x-1/2 w-[120%] h-[80%] rounded-full bg-blue-600/10 blur-[120px]" data-id="element-152"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-sky-500/5 blur-[100px]" data-id="element-153"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-154">
        <div className="max-w-4xl mx-auto text-center" data-id="element-155">
          {/* Brand mark */}
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 mb-8 text-sky-400 font-bold tracking-wide items-center justify-start" data-id="element-156">
            🇦🇷 CENTRALPACK™
          </motion.div>

          {/* Massive headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tight mb-4 text-balance text-[28px]" data-id="element-157">
            Todo tu aprendizaje de Señas.
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tight mb-12 text-sky-400 text-balance text-[32px]" data-id="element-158">
            Listo. Desde hoy.
          </motion.h2>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="relative max-w-2xl mx-auto mb-12" data-id="element-159">
            <img src="https://cdn.magicpatterns.com/uploads/kNbF2nj69rFvWQiUeoMibD/ChatGPT_Image_19_may_2026,_18_51_03.png" alt="CentralPack MegaPack LSA Listo - Lenguaje de Señas Argentina" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(56,189,248,0.25)]" data-id="element-160" />
          </motion.div>

          {/* Tagline in accent color */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-xl md:text-2xl font-bold text-sky-400 mb-4 text-balance" data-id="element-161">
            El sistema N°1 para aprender Lenguaje de Señas Argentina — Nivel 0 →
            Avanzado — Para todos
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto text-balance" data-id="element-162">
            Vocabulario + frases + práctica lista para usar. Sin buscar. Sin
            improvisar. Sin quedarte en blanco.
          </motion.p>

          {/* Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-163">
            {badges.map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-slate-900/80 border border-slate-700 text-sm font-semibold backdrop-blur-sm" data-id="element-164">
                <span data-id="element-165">{badge.icon}</span> {badge.text}
              </span>)}
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-166">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-sky-500 hover:bg-sky-400 text-white text-lg font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(56,189,248,0.6)] hover:shadow-[0_15px_50px_-10px_rgba(56,189,248,0.8)] transition-all hover:-translate-y-1" data-id="element-167">
              QUIERO MI CENTRALPACK AHORA
              <ArrowRight className="w-5 h-5" data-id="element-168" />
            </button>
          </motion.div>

          {/* Trust signals */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-slate-400 font-medium" data-id="element-169">
            <div className="flex items-center gap-1.5" data-id="element-170">
              <Shield className="w-4 h-4 text-emerald-400" data-id="element-171" />
              <span data-id="element-172">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173">
              <Lock className="w-4 h-4 text-emerald-400" data-id="element-174" />
              <span data-id="element-175">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-176">
              <CreditCard className="w-4 h-4 text-sky-400" data-id="element-177" />
              <span data-id="element-178">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}